import Auth0Client from '../../auth/Auth0Client';
import { saveExpirableStringToLS } from '../appStateLocalStorage';

export default () => {
  const encodedAppPath = window.btoa(window.location.pathname + window.location.hash);
  saveExpirableStringToLS(encodedAppPath);
  return new Auth0Client(encodedAppPath);
};
